import { render, staticRenderFns } from "./CompletedTodos.vue?vue&type=template&id=270308ee&"
import script from "./CompletedTodos.vue?vue&type=script&lang=js&"
export * from "./CompletedTodos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports